<template>
  <div class="wrap m-a ov-h" id="wrap">
    <!-- banner:start -->
    <section class="contact-banner banner p-r">
      <div class="contact-img p-r">
        <i></i>
        <div class="contact-banner-txt p-a c">
          <h1>Contact Us</h1>
          <h4>24/7 Customer Support</h4>
        </div>
      </div>
    </section>
    <!-- <a name="quotation"></a> -->
    <section class="area-1 p-r in-pc" id="quotation">
      <img class="contact-us" src="@/assets/images/contact/contact-us.jpg" alt="" srcset="" />
      <div class="contact-us-right">
        <div class="right-content">
          <div class="quotation-box right-warp">
            <img
              class="quotation"
              src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-width='3' fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.84 9h22.917c.666 0 1.206.54 1.206 1.206v4.307c0 .666-.54 1.206-1.206 1.206H19.84c-.666 0-1.206-.54-1.206-1.206v-4.307c0-.666.54-1.206 1.206-1.206z'/%3E%3Cpath d='M45.17 12.054h4.22c.667 0 1.207.533 1.207 1.19v4.307m.054 27.189c0 2.526-.054 4.431-.054 10.07 0 .657-.54 1.19-1.206 1.19H13.206A1.198 1.198 0 0 1 12 54.81V13.245c0-.657.54-1.19 1.206-1.19h5.428' stroke-linecap='round'/%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M52.88 22.364l5.97 6.047-18.744 18.984-7.269 1.316 1.3-7.363z'/%3E%3Cpath stroke-linecap='round' d='M19.237 25.21h19.298M19.237 33.761h12.061'/%3E%3C/g%3E%3C/svg%3E"
              alt=""
              srcset=""
            />
            <h5>Quotation</h5>
            <p>Looking for our product pricing information? Leave us a message and we will contact you soon.</p>
          </div>

          <div class="email-warp right-warp">
            <img
              class="email-img"
              src="data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(4 6.667)' stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Crect x='1' y='1' width='22' height='16.667' rx='1.333'/%3E%3Cpath d='M1.333 1.333l10.228 8.95c.251.22.627.22.878 0l10.228-8.95'/%3E%3C/g%3E%3C/svg%3E"
              alt=""
              srcset=""
            />
            <span class="email">Email</span>
            <!-- <p>sales.global@fjdynamics.com</p> -->
            <p>
              <a class="c-26 a-hover a-bottom-line" href="mailto:sales.global@fjdynamics.com"
                >sales.global@fjdynamics.com</a
              >
            </p>
          </div>

          <div class="phone-warp right-warp">
            <img
              class="phone-img"
              src="data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h32v32H0z'/%3E%3Cpath d='M11.499 4.667c.504 0 .968.273 1.212.713l1.696 3.055c.222.4.232.884.028 1.293L12.8 12.995s.474 2.434 2.455 4.416c1.981 1.981 4.407 2.446 4.407 2.446l3.267-1.633c.41-.204.893-.194 1.293.029l3.064 1.702c.44.245.713.709.713 1.212v3.517c0 1.791-1.663 3.085-3.36 2.512-3.486-1.176-8.896-3.415-12.325-6.844-3.428-3.43-5.668-8.84-6.844-12.325-.574-1.697.72-3.36 2.512-3.36h3.516z' stroke='%23191923' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E"
              alt=""
              srcset=""
            />
            <span class="phone">24/7 Hotline</span>
          </div>
          <div class="bottom-warp right-warp d-f">
            <div class="bottom-warp-col">
              <p class="c-59 bottom-warp-tit">Singapore:</p>
              <p class="c-26 bottom-warp-val">+65 800 492 2588</p>
            </div>
            <div class="bottom-warp-col">
              <p class="c-59 bottom-warp-tit">Poland:</p>
              <p class="c-26 bottom-warp-val">+48 717 079 292</p>
            </div>
            <div class="bottom-warp-col">
              <p class="c-59 bottom-warp-tit">Brazil:</p>
              <p class="c-26 bottom-warp-val">+551 130 422 812</p>
            </div>
            <div class="bottom-warp-col">
              <p class="c-59 bottom-warp-tit">US:</p>
              <p class="c-26 bottom-warp-val">+65 8004922588</p>
              <p class="c-26 bottom-warp-val">+1 864 406 0078</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <a name="moreEmail"></a> -->
    <section class="area-2" id="moreEmail">
      <div class="item-col d-f fd-c jc-sb">
        <div>
          <img
            class="area-2-top-img"
            src="data:image/svg+xml,%3Csvg width='68' height='64' viewBox='0 0 68 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23F2F2F4' cx='49' cy='43' r='19'/%3E%3Cg stroke='%23262626' stroke-width='3'%3E%3Cpath d='M52.5 39.5L39.237 52.874c-3.93 3.895-10.303 3.895-14.234 0L5.684 33.733a5.662 5.662 0 0 1 0-8.059L18.81 12.67a5.789 5.789 0 0 1 8.134 0l5.041 4.995'/%3E%3Cpath d='M52.5 39.5l5.669-5.772a5.662 5.662 0 0 0 .146-8.2L45.337 12.67a5.789 5.789 0 0 0-8.134 0l-10.019 9.5a4.313 4.313 0 0 0-.068 6.194l1.152 1.142a6.128 6.128 0 0 0 8.627 0l2.876-2.849L52.5 39.5z'/%3E%3Cg stroke-linecap='round'%3E%3Cpath d='M31.793 45.448l7.052 7.052M37.893 39.348l7.052 7.052'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
            alt=""
          />
          <h5 class="area-2-h5">Business Cooperation</h5>
          <p class="area-2-p">Get in touch with our marketing team for business cooperation.</p>
        </div>
        <div class="area-2-email-warp">
          <img
            class="area-2-email-img"
            src="data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(4 6.667)' stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Crect x='1' y='1' width='22' height='16.667' rx='1.333'/%3E%3Cpath d='M1.333 1.333l10.228 8.95c.251.22.627.22.878 0l10.228-8.95'/%3E%3C/g%3E%3C/svg%3E"
            alt=""
            srcset=""
          />
          <span class="area-2-email">Email</span>
          <p class="area-2-p">
            <a class="a-hover a-bottom-line" href="mailto:sales.global@fjdynamics.com">sales.global@fjdynamics.com</a>
          </p>
        </div>
      </div>
      <div class="item-col d-f fd-c jc-sb">
        <div>
          <img
            class="area-2-top-img"
            src="data:image/svg+xml,%3Csvg width='68' height='64' viewBox='0 0 68 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23F2F2F4' cx='49' cy='41' r='19'/%3E%3Cg stroke='%23262626' stroke-width='3'%3E%3Cpath d='M11 49.333a2.667 2.667 0 0 1-2.667-2.666V12A2.667 2.667 0 0 1 11 9.333h42A2.667 2.667 0 0 1 55.667 12v34.667A2.667 2.667 0 0 1 53 49.333H32.667l-11.355 8.832a.4.4 0 0 1-.645-.316v-8.516H11z' stroke-linejoin='round'/%3E%3Ccircle cx='32' cy='21.333' r='6.667'/%3E%3Cpath d='M18 42.6c0-5.523 4.477-10 10-10h8c5.523 0 10 4.477 10 10' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
            alt=""
          />
          <h5 class="area-2-h5">Public Relations</h5>
          <p class="area-2-p">Contact us for media inquiries, or to seek cooperation for marketing campaign.</p>
        </div>
        <div class="area-2-email-warp">
          <img
            class="area-2-email-img"
            src="data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(4 6.667)' stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Crect x='1' y='1' width='22' height='16.667' rx='1.333'/%3E%3Cpath d='M1.333 1.333l10.228 8.95c.251.22.627.22.878 0l10.228-8.95'/%3E%3C/g%3E%3C/svg%3E"
            alt=""
            srcset=""
          />
          <span class="area-2-email">Email</span>
          <p class="area-2-p">
            <a class="a-hover a-bottom-line" href="mailto:PR@fjdynamics.com">PR@fjdynamics.com</a>
          </p>
        </div>
      </div>
      <div class="item-col d-f fd-c jc-sb">
        <div>
          <img
            class="area-2-top-img"
            src="data:image/svg+xml,%3Csvg width='68' height='64' viewBox='0 0 68 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23F2F2F4' cx='49' cy='41' r='19'/%3E%3Cg transform='translate(9 9)'%3E%3Crect stroke='%23262626' stroke-width='3' width='47' height='47' rx='5.222'/%3E%3Cpath d='M22.978 13.106C16.824 8.694 11.092 7.019 8.73 9.382c-3.157 3.158.896 12.33 9.053 20.488a54.308 54.308 0 0 0 1.683 1.612m4.06 3.356c6.34 4.68 12.319 6.512 14.746 4.085 3.157-3.157-.896-12.33-9.053-20.488a54.293 54.293 0 0 0-1.707-1.634' stroke='%23262626' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M34.652 23.484c4.333-6.098 5.963-11.758 3.619-14.102-3.158-3.158-12.331.895-20.489 9.053a54.308 54.308 0 0 0-1.612 1.682m-3.355 4.06c-4.68 6.34-6.512 12.32-4.086 14.746 3.158 3.158 12.331-.895 20.489-9.053a54.293 54.293 0 0 0 1.634-1.706' stroke='%23262626' stroke-width='3' stroke-linecap='round'/%3E%3Ccircle fill='%23262626' cx='23.5' cy='23.5' r='1.958'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
            alt=""
          />
          <h5 class="area-2-h5">Technical Support</h5>
          <p class="area-2-p">Contact us for technical support from FJD team</p>
        </div>
        <div class="area-2-email-warp">
          <img
            class="area-2-email-img"
            src="data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(4 6.667)' stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Crect x='1' y='1' width='22' height='16.667' rx='1.333'/%3E%3Cpath d='M1.333 1.333l10.228 8.95c.251.22.627.22.878 0l10.228-8.95'/%3E%3C/g%3E%3C/svg%3E"
            alt=""
            srcset=""
          />
          <span class="area-2-email">Email</span>
          <p class="area-2-p">
            <a class="a-hover a-bottom-line" href="mailto:service@fjdynamics.com">service@fjdynamics.com</a>
          </p>
        </div>
      </div>
      <div class="item-col d-f fd-c jc-sb">
        <div>
          <img
            class="area-2-top-img"
            src="data:image/svg+xml,%3Csvg width='68' height='64' viewBox='0 0 68 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23F2F2F4' cx='49' cy='41' r='19'/%3E%3Cg stroke='%23262626' stroke-width='3'%3E%3Cpath stroke-linecap='round' d='M6.666 52h50.667'/%3E%3Cpath d='M19.89 52.11L8.783 41.003a4.063 4.063 0 0 1 0-5.746L32.59 11.449a4.063 4.063 0 0 1 5.747 0l16.88 16.881a4.063 4.063 0 0 1 0 5.747L37.314 51.98'/%3E%3Cpath d='M9.844 42.68l19.962-3.696a8.127 8.127 0 0 0 6.511-6.511l3.697-19.962'/%3E%3Cpath stroke-linecap='round' d='M8 8.667V20M15.333 8.667V16M22.666 8.667v4.666'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
            alt=""
          />
          <h5 class="area-2-h5">Feedback & Advice</h5>
          <p class="area-2-p">
            Feel free to contact us if you have any advice about our products, services and dealers.
          </p>
        </div>
        <div class="area-2-email-warp">
          <img
            class="area-2-email-img"
            src="data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(4 6.667)' stroke='%23262626' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Crect x='1' y='1' width='22' height='16.667' rx='1.333'/%3E%3Cpath d='M1.333 1.333l10.228 8.95c.251.22.627.22.878 0l10.228-8.95'/%3E%3C/g%3E%3C/svg%3E"
            alt=""
            srcset=""
          />
          <span class="area-2-email">Email</span>
          <p class="area-2-p">
            <a class="a-hover a-bottom-line" href="mailto:feedback@fjdynamics.com">feedback@fjdynamics.com</a>
          </p>
        </div>
      </div>
    </section>

    <section class="area-3"></section>

    <!-- banner:end -->
    <section class="area-3 join p-r">
      <div class="p-r m-a">
        <div class="contact-join p-r">
          <div>
            <i class="p-r">
              <div class="join-txt p-a c-c">
                <h5>Get In Touch On Social Media</h5>
                <h6>Reach out on social media and see what other FJDers have to say.</h6>
              </div>
            </i>
          </div>

          <ul class="join-ask ov-h">
            <!-- <li class="join-fjd p-r d-n">
                            <b>Join FJD Community</b>
                            <a href="">DISCUSSUION</a>
                        </li> -->
            <li class="ask">
              <!-- <b>Ask Us on Social</b> -->
              <div>
                <a href="https://www.facebook.com/FJDynamicsglobal/" target="_blank" class="facebook"></a>
                <a
                  href="https://www.linkedin.com/company/fjdynamicsglobal/?viewAsMember=true"
                  target="_blank"
                  class="linkedin"
                ></a>
                <a href="https://instagram.com/fjdynamics?igshid=e5vkxd17plf0" target="_blank" class="instagram"></a>
                <a
                  href="https://www.youtube.com/channel/UCNuv_Ku3e95adnYs4mufAeA/featured?view_as=subscriber"
                  target="_blank"
                  class="youtube"
                ></a>
                <a href="https://twitter.com/FJDynamics" target="_blank" class="twitter"></a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- footer:start -->
    <!-- footer:end -->
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    watch: {
      '$route.hash': {
        handler(newVal, oldVal) {
          console.log('[ val,oldVal ] >', { newVal, oldVal })
          // if (newVal !== oldVal) {
          this.scrollIntoView(newVal)
          // }
        }
      }
    },
    // watchQuery: true,
    mounted() {
      this.scrollIntoView(this.$router.currentRoute.hash)
      console.log('[ this.$router ] >', this.$router.currentRoute.hash)
    },
    methods: {
      scrollIntoView(id) {
        console.log('[ id ] >', id)
        this.$nextTick(() => {
          if (!id) return
          document.querySelector(`${id}`).scrollIntoView()
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  /* body {
  min-width: 1200px;
}
.w1000px {
  width: 1000px;
}
.w1200px {
  width: 1200px;
} */
  .join {
    padding-bottom: 100px;
    /* background-color: #f7f7f7; */
  }
  .contact-img i {
    display: block;
    position: relative;
    width: 100%;
    height: 3.6rem;
    background: url('@/assets/images/contact/banner.jpg') no-repeat center;
    background-size: cover;
  }
  /* .contact-img i:before {
  display: block;
  content: "";
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
} */
  .contact-banner {
    margin-top: 3.958vw;
  }
  .contact-banner-txt {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .contact-banner-txt h1 {
    text-align: center;
    position: relative;
    width: 100%;
    font-size: 0.48rem;
    color: #ffffff;
    font-weight: 700;
    margin-bottom: 0.08rem;
  }
  .contact-banner-txt h4 {
    width: 100%;
    text-align: center;
    height: 32px;
    font-size: 0.24rem;
    color: #ffffff;
    text-shadow: 0px 2px 7px rgba(0, 0, 0, 0.5);
    font-weight: 500;
  }

  .area-1 {
    margin: 1.04rem 0.56rem 0;
  }
  .area-1 .contact-us {
    position: absolute;
    top: -0.24rem;
    width: 8.2rem;
    height: 4.63rem;
    display: inline-block;
  }
  .contact-us-right {
    background: url('@/assets/images/contact/m-bg.png') no-repeat center;
    background-size: cover;
    width: 16.4rem;
    height: 5.54rem;
    margin-left: 1.5rem;
  }
  .right-content {
    margin-left: 7.38rem;
  }
  .right-content .right-warp {
    margin-bottom: 0.29rem;
  }
  .right-content .right-warp:last-child {
    margin-top: -0.17rem;
  }

  .right-content .quotation {
    width: 0.64rem;
    height: 0.64rem;
    margin-top: 0.48rem;
  }
  .right-content h5 {
    height: 0.42rem;
    font-size: 0.28rem;
    color: #262626;
    line-height: 1.5;
    margin-bottom: 0.12rem;
    margin-top: 0.08rem;
    font-weight: 500;
  }

  .right-content p {
    font-size: 0.2rem;
    color: #262626;
    line-height: 1.5;
  }

  .email-warp .email-img {
    width: 0.32rem;
    height: 0.32rem;
    vertical-align: text-bottom;
  }
  .email-warp .email {
    height: 0.42rem;
    font-size: 0.28rem;
    color: #262626;
    font-weight: 500;
  }
  .phone-warp .phone {
    height: 0.42rem;
    font-size: 0.28rem;
    font-weight: 500;
    color: #262626;
  }
  .phone-warp .phone-img {
    width: 0.32rem;
    height: 0.32rem;
    vertical-align: text-bottom;
  }
  .bottom-warp .bottom-warp-col {
    margin-right: 0.5rem;
  }

  .bottom-warp-tit {
    font-size: 0.2rem;
  }
  .bottom-warp-val {
    font-size: 0.2rem;
    cursor: pointer;
    color: #262626;
  }
  .bottom-warp-val:hover {
    color: #3081f2;
  }

  /* .area-2 */
  .area-2 {
    padding: 1rem 6.88vw;
    margin: 0 -2.13vw;
    display: flex;
    align-items: center;
  }
  .area-2 .item-col {
    padding: 0 0.33rem 0 0.42rem;
    border-right: 1px solid #d4d4d4;
    height: 3.36rem;
    box-sizing: border-box;
    flex: 1;
  }
  .area-2 .item-col:last-child {
    border-right: 1px solid transparent;
  }

  .area-2-top-img {
    width: 0.68rem;
    height: 0.64rem;
    margin-bottom: 0.24rem;
  }
  .area-2-h5 {
    font-weight: 500;
    font-size: 0.28rem;
    color: #262626;
    margin-bottom: 0.12rem;
  }
  .area-2-p {
    font-size: 0.2rem;
    color: #262626;
    margin-top: 0.08rem;
    line-height: 1.5;
  }
  .area-2-email-img {
    width: 0.32rem;
    height: 0.32rem;
    vertical-align: text-bottom;
  }
  .area-2-email {
    font-size: 0.28rem;
    color: #262626;
    font-weight: 500;
  }

  /* area-3 */
  .area-3 {
    padding: 0 2.92vw;
  }

  .email-box {
    padding: 60px 0 0 0;
    color: #000;
    margin-left: -90px;
  }
  .email-box a,
  .supply-box a {
    color: #666;
  }
  .email-box li {
    float: left;
    width: 332px;
    margin-bottom: 40px;
    margin-left: 90px;
  }
  .email-box li div {
    padding-left: 0px;
  }
  .email-box h5,
  .supply-box h5 {
    font-size: 20px;
    margin-bottom: 10px;
    font-weight: 700;
  }
  .email-box b,
  .supply-box b {
    display: block;
    font-size: 18px;
  }
  /* .email-box a:after{display:inline-block; position: relative; top:2px; margin-left:10px; content: "";width: 8px;height: 14px; background: url("/images/arr_b.png");} */
  .email-box a:hover,
  .supply-box a:hover {
    color: #000;
  }
  .supply-box {
    color: #000;
    font-size: 26px;
    padding-top: 45px;
  }
  .supply-box .txt {
    font-weight: 700;
    line-height: 42px;
  }
  .supply-box ul {
    padding-top: 70px;
    overflow: hidden;
    margin-left: -90px;
  }
  .supply-box li {
    display: inline-block;
    margin-bottom: 40px;
    width: 332px;
    margin-left: 90px;
  }
  .supply-box .txt {
    line-height: 1;
    color: #999;
  }
  .supply-box .txt b {
    font-size: 28px;
    color: #000;
  }
  .supply-box .txt span {
    font-size: 16px;
    font-weight: 400;
  }
  .contact-join {
    color: #fff;
  }
  .contact-join i {
    display: block;
    height: 3rem;
    width: 100%;
    background: url('@/assets/images/contact/bottom-bg.jpg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .contact-join .join-txt {
    width: 100%;
    text-align: center;
  }
  .contact-join h5 {
    margin-bottom: 0.08rem;
    font-weight: 700;
    font-size: 0.44rem;
    color: #ffffff;
  }
  .contact-join h6 {
    font-family: 'Alibaba Sans';
    font-size: 0.2rem;
    color: #ffffff;
    text-shadow: 0px 2px 7px rgba(0, 0, 0, 0.5);
  }
  .join-ask {
    color: #000;
    padding: 0.8rem 0;
    background-color: #fff;
  }
  .join-ask li {
    width: 50%;
    float: left;
    text-align: center;
    float: none;
    width: 100%;
  }
  .join-ask b {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 55px;
    display: block;
  }
  .join-fjd a {
    display: block;
    margin: 0 auto;
    transition: all 0.3s;
    width: 172px;
    height: 50px;
    position: relative;
    line-height: 50px;
    border-radius: 25px;
    border: 1px solid #666;
    font-size: 16px;
    text-align: left;
    text-indent: 35px;
    color: #000;
  }
  .join-fjd a:after {
    content: '';
    display: block;
    width: 18px;
    height: 19px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 15px;
    background: url('/images/cicl_ico_n.png');
  }
  .join-fjd a:hover {
    border-color: #ffc550;
    color: #ffc550;
  }
  .join-fjd a:hover:after {
    background-image: url('/images/cicl_ico_h.png');
  }
  .join-fjd:after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    font-size: 0;
    height: 90%;
    background-color: #eee;
  }
  .ask a {
    z-index: 9;
    margin: 0 30px;
    display: inline-block;
    width: 40px;
    height: 40px;
    margin: 0 15px;
    background-repeat: no-repeat;
    background-position: center;
    transition: all 0.3s linear;
  }
  .ask a,
  .ask a:hover {
    background-size: cover;
  }
  .ask a:hover {
    transform: scale(1.1);
  }
  /* .ask .instagram{background-image:url("/images/in_ico66.png");}
    .ask .facebook{background-image:url("/images/f_ico66.png");} */
  .ask .facebook {
    background-image: url('@/assets/images/contact/facebook.png');
  }
  .ask .linkedin {
    background-image: url('@/assets/images/contact/linkedin.png');
  }
  .ask .youtube {
    background-image: url('@/assets/images/contact/youtube.png');
  }
  .ask .instagram {
    background-image: url('@/assets/images/contact/instagram.png');
  }
  .ask .twitter {
    background-image: url('@/assets/images/contact/twitter.png');
  }
  .a-hover {
    color: #262626;
  }
  .a-hover:hover {
    color: #3081f2;
  }

  .a-bottom-line:hover {
    border-bottom: 1px solid #3081f2;
  }

  @media screen and (max-width: 1050px) {
    .bottom-warp .bottom-warp-col {
      margin-right: 0.2rem;
    }
  }

  @media screen and (max-width: 992px) {
    .bottom-warp .bottom-warp-col {
      margin-right: 0.16rem;
    }
    .right-content p {
      font-size: 0.14rem;
    }
  }
</style>
